module.exports = __webpack_public_path__ + "img/cancel.c7d0e48d.png";